import React, { useState } from "react";
import { Heart } from "iconsax-react";
import Swal from "sweetalert2";
import MobileLayout from "../../components/MobileLayout";

import {
  Container,
  InfoCard,
  CharactersBox,
  PixCard,
  ApoiaBtn,
  Subtitle,
} from "./styles";

import lillaImg from "../../assets/images/lilla.png";
import biliImg from "../../assets/images/bili.png";
import batataImg from "../../assets/images/batata.png";
import nubankImg from "../../assets/images/nubank.png";

const Support: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const PIX_KEY = "40.146.101/0001-90";

  const handleCopyPix = () => {
    navigator.clipboard.writeText(PIX_KEY);
    setCopied(true);

    Swal.fire({
      icon: "success",
      title: "Chave PIX copiada!",
      text: "Agora você pode colar no seu aplicativo do banco para realizar o apoio.",
      timer: 2000,
      showConfirmButton: false,
    });

    setTimeout(() => setCopied(false), 2000);
  };

  const handleOpenApoiaSe = () => {
    window.open("https://apoia.se/bilinguahub", "_blank");
  };

  return (
    <MobileLayout headerTitle="Apoiar o Sinalário" headerType="private">
      <Container>
        <InfoCard>
          <h2>Apoie o Projeto</h2>
          <p>
            O Sinalário de Libras é um projeto independente e gratuito. Seu
            apoio é fundamental para mantermos os servidores ativos e
            continuarmos gravando novos sinais!
          </p>

          <CharactersBox>
            <img src={lillaImg} alt="Lilla" className="lilla" />
            <img src={biliImg} alt="Bili" className="bili" />
            <img src={batataImg} alt="Batata" className="batata" />
          </CharactersBox>

          <p style={{ fontSize: "13px", fontWeight: 600 }}>
            Lilla, Bili e Batata agradecem seu carinho! 💜
          </p>
        </InfoCard>

        <PixCard>
          <h3>Apoiar por PIX</h3>
          <img src={nubankImg} alt="Nubank" className="bank-logo" />

          <div style={{ width: "100%" }}>
            <span className="pix-label">Chave CNPJ (Copia e Cola):</span>
            <div
              className="pix-key"
              onClick={handleCopyPix}
              onKeyDown={(e) => e.key === "Enter" && handleCopyPix()}
              role="button"
              tabIndex={0}
            >
              {copied ? "COPIADO!" : PIX_KEY}
            </div>
          </div>

          <div className="pix-details">
            <p>
              Empresa: <strong>Bilingua HUB de Acessibilidade</strong>
            </p>
            <p>
              Banco: <strong>Nu Pagamentos S.A. (Nubank)</strong>
            </p>
          </div>
        </PixCard>

        <ApoiaBtn onClick={handleOpenApoiaSe}>
          <Heart size={24} variant="Bold" color="white" />
          Apoiar na Apoia.se
        </ApoiaBtn>

        <Subtitle>
          Contribua mensalmente e ganhe recompensas exclusivas!
        </Subtitle>
      </Container>
    </MobileLayout>
  );
};

export default Support;
